import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Dialogue de saisie du code PIN (creation ou changement) de la barre du haut : pave numerique
 * et pastilles.
 *
 * Presentationnel : l'etat de la saisie (mode, etape, chiffres, erreur) vient de la barre, qui
 * recoit chaque chiffre, chaque effacement et la fermeture. La barre decide de l'afficher.
 */
@Component({
  selector: 'app-topbar-pin-change-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './topbar-pin-change-dialog.component.html',
  styleUrls: [
    '../styles/topbar-partage-01.css',
    '../styles/topbar-partage-04.css',
    '../styles/topbar-pin-change-dialog-01.css',
  ],
  styles: [':host { display: contents; }'],
})
export class TopbarPinChangeDialogComponent {
  readonly pinChangeMode = input.required<'setup' | 'change'>();
  readonly pinChangeStep = input.required<'current' | 'new' | 'confirm'>();
  readonly pinChangeDigits = input.required<string[]>();
  readonly pinChangeError = input.required<string>();

  readonly closed = output<void>();
  readonly digitEntered = output<string>();
  readonly digitDeleted = output<void>();
}
